// extracted by mini-css-extract-plugin
export default {"imageWrapper":"nK-z","twoColumnImage":"oK-z"};